import $ from 'jquery';
import util from '../../../service/util/Util';
import BasePropertyView from 'BasePropertyView.js';
import lengthTemplate from 'properties/advanced/appendix-size.ejs';
import TextUtil from 'util/TextUtil.js';

class AppendixSizeView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = lengthTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[name=appendixHeight]'     : 'updateAppendixSize',
            'change input[name=appendixWidth]'      : 'updateAppendixSize',
            'change select[name=appendixSizePreset]' : 'updateAttributes',
            'change select[name=appendixUnit]'       : 'updateAttributes',
            'change input[name=appendixDpi]'        : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'keydown input[type=text]' : 'validatePositiveNumeric'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(evt){
        evt.preventDefault();

        const propName = evt.currentTarget.name.trim();
        const propVal  = evt.currentTarget.value.trim();

        if (propName === 'appendixSizePreset') {
            this.setPrefixedSize(propVal);
        }

        this.model.set( propName, propVal );
    }

    updateAppendixSize(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        const valueConverted=util.convertFromUnitToPixel(
            parseFloat(propVal),
            this.model.get('appendixUnit'),
            this.model.get('appendixDpi'));


        this.model.set( propName, valueConverted );
    }

    updateDPI(evt){
        evt.preventDefault();
        const propName = evt.currentTarget.name;
        const propVal  = parseFloat(evt.currentTarget.value);

        // Obtaining the values already converted.
        const currentWidthDisplayed=$('input[name=appendixWidth]').val();
        const currentHeightDisplayed=$('input[name=appendixHeight]').val();

        const newWidth=util.convertFromUnitToPixel(
            currentWidthDisplayed,
            this.model.get('appendixUnit'),
            propVal);

        const newHeight=util.convertFromUnitToPixel(
            currentHeightDisplayed,
            this.model.get('appendixUnit'),
            propVal);

        this.model.set( propName, propVal );
        this.model.set( 'appendixWidth', newWidth);
        this.model.set( 'appendixHeight', newHeight  );

    }

    setPrefixedSize(option) {
        switch (option){
            case 'letter':
                this.model.set('appendixHeight','792',{silent:true});
                this.model.set('appendixWidth','612',{silent:true});
                this.model.set('appendixUnit','inch',{silent:true});
                break;
            case 'legal':
                this.model.set('appendixHeight','1008',{silent:true});
                this.model.set('appendixWidth','612',{silent:true});
                this.model.set('appendixUnit','inch',{silent:true});
                break;
            case 'executive':
                this.model.set('appendixHeight','756',{silent:true});
                this.model.set('appendixWidth','522',{silent:true});
                this.model.set('appendixUnit','inch',{silent:true});
                break;
            case 'a4':
                this.model.set('appendixHeight','842',{silent:true});
                this.model.set('appendixWidth','595',{silent:true});
                this.model.set('appendixUnit','mm',{silent:true});
                break;
            case 'a5':
                this.model.set('appendixHeight','595',{silent:true});
                this.model.set('appendixWidth','481',{silent:true});
                this.model.set('appendixUnit','mm',{silent:true});
                break;
            case 'b4':
                this.model.set('appendixHeight','1001',{silent:true});
                this.model.set('appendixWidth','709',{silent:true});
                this.model.set('appendixUnit','mm',{silent:true});
                break;
            case 'b5':
                this.model.set('appendixHeight','709',{silent:true});
                this.model.set('appendixWidth','499',{silent:true});
                this.model.set('appendixUnit','mm',{silent:true});
                break;
            default: break;
        }
    }

    render() {
        this.$el.empty();

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
       this.updateAppendix();

        $("option[value='"+this.model.get('appendixSizePreset')+"']").attr( "selected", true );
        $("option[value='"+this.model.get('appendixUnit')+"']").attr( "selected", true );
        
        this.delegateEvents();
        return this;
    }

    updateAppendix() {
        //set selected index to model value
        if(this.model.get('appendixSizePreset')) {
            $('#appendixSizePreset').find("option[value='"+this.model.get('appendixSizePreset')+"']").attr('selected', true);
        }

        if(this.model.get('appendixUnit')) {
            $('#appendixUnit').find("option[value='"+this.model.get('appendixUnit')+"']").attr('selected', true);
        }
    }

}

export default AppendixSizeView;
